export const ru = {
    error_title: 'Что-то пошло не так',
    error_description: 'Попробуйте перезагрузить страницу или обратиться в поддержку, если ошибка повторяется',
    delete_travel_policy: 'Удалить тревел-политику',
    confirmation_delete_title: 'Подтверждение',
    confirmation_delete_message: 'Вы точно хотите удалить тревел-политику?',
};
